import React from 'react';
import { TrendingUp } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { cn } from '../ui/utils';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon: React.ElementType;
  iconClassName?: string;
  /**
   * Colour for the value itself. Optional and additive: the Learning stat tiles need to
   * flag amber In-progress / emerald Completed / red Overdue counts, which the hard-coded
   * value classes below cannot express (LEARNING.md §13.12). Existing callers are
   * unaffected because the default is empty.
   */
  valueClassName?: string;
  trend?: {
    value: string | number;
    isPositive?: boolean;
  };
  className?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon: Icon,
  iconClassName,
  valueClassName,
  trend,
  className
}) => {
  return (
    <Card className={cn("hover:shadow-md transition-shadow", className)}>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between mb-4">
          <div className={cn("p-2 rounded-lg", iconClassName)}>
            <Icon size={20} className="text-white" />
          </div>
          {trend ? (
            <div className={cn(
              "flex items-center gap-1 text-xs font-medium",
              trend.isPositive !== false ? "text-green-600" : "text-red-600"
            )}>
              <TrendingUp size={14} />
              {trend.value}
            </div>
          ) : (
            <TrendingUp size={16} className="text-muted-foreground/30" />
          )}
        </div>
        <div>
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider">{title}</p>
          <h3 className={cn("text-2xl font-bold mt-1 tracking-tight", valueClassName)}>{value}</h3>
        </div>
      </CardContent>
    </Card>
  );
};
